import React, { useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { CircularProgress, TextField } from "@mui/material";
import { Field, ErrorMessage } from "formik";
import Error from "./ErrorMessage";
import { LOCAL_STORAGE } from "Components/Constants/LocalStorage";

export default function AsynchronousAutoComplete(props) {
  
  const { getOptionLabel, label, name, Service, onChange,withoutLocationFilter, ...rest } = props;

  const [inputValue, setInputValue] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  let locationCode = JSON.parse(localStorage.getItem(LOCAL_STORAGE.BIZX_LOCATION)).code;

  const handleInputValueChange = (e, newValue) => {
    setInputValue(newValue);
    newValue.length > 0 ? setLoading(true) : setOptions([]);
    newValue.length >= 3 &&
      newValue.length <= 50 &&
      (async () => {
        const response = await Service.search(newValue);
        const locationFilterdData = response.filter((row)=>row.stockLocationCode == locationCode);    
        withoutLocationFilter ? setOptions(response) : setOptions(locationFilterdData);
        setLoading(false);
      })();
  };

  useEffect(() => {
    open && options.length === 0 && setLoading(true);
  }, [open, options.length]);

  return (
    <Field name={name}>
      {(fieldProps) => {
        const { setFieldValue, values } = fieldProps.form;

        return (
          <>
            <Autocomplete
              autoHighlight
              open={open}
              onClose={() => {
                setOpen(false);
              }}
              onOpen={() => {
                setOpen(true);
              }}
              clearOnEscape
              value={values[name] === "" ? null : values[name]}
              getOptionLabel={
                getOptionLabel
                  ? getOptionLabel
                  : (option) => option.name + " - " + option.barcode 
              }
              {...rest}
              onChange={
                onChange
                  ? onChange
                  : (event, newValue) => setFieldValue(name, newValue)
              }
              options={options}
              loading={loading}
              inputValue={inputValue}
              onInputChange={handleInputValueChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label={label}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading && open ? (
                          <CircularProgress color="inherit" size={15} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
            <ErrorMessage name={name} component={Error} />
          </>
        );
      }}
    </Field>
  );
}
